import { foldDigits } from '@/lib/text/fold-digits'

/**
 * The count an analyst types to confirm a remediation, read the way a person writes a number:
 * native digits folded (Arabic-Indic, Persian, Devanagari) and grouping separators ignored, so
 * "1,234", "1 234" and the Arabic "1" "2" "3" "4" with its thousands separator all confirm 1234.
 * There is no `maxLength` on the field for the same reason: "1,234,567" is longer than "1234567".
 *
 * The separators, as code points (so none of them is an invisible character in this file):
 * comma, full stop, apostrophe, right single quote, Arabic thousands separator U+066C, Arabic
 * decimal separator U+066B, Arabic comma U+060C, underscore, no-break space U+00A0, narrow
 * no-break space U+202F and thin space U+2009. Ordinary whitespace is ignored as well.
 */
const GROUPING_CODE_POINTS = [0x2c, 0x2e, 0x27, 0x2019, 0x66c, 0x66b, 0x60c, 0x5f, 0xa0, 0x202f, 0x2009]
const GROUPING = new RegExp(`[\\s${GROUPING_CODE_POINTS.map((cp) => String.fromCodePoint(cp)).join('')}]`, 'gu')

export function normalizeTypedCount(raw: string): string {
  return foldDigits(raw).replace(GROUPING, '')
}

/** The ASCII digits of the count the server says it will act on: the phrase the analyst must type. */
export function typedCountPhrase(messages: number): string {
  return String(Math.max(0, Math.trunc(messages)))
}
